module.exports = "/assets/data/553312da88030fc1b68f027f4faaf248-SL2.data.json";